













import { Component, Vue, Prop } from 'vue-property-decorator';
import { language } from '@tencent/ppd-base-libs';
import SDK from '@/business/sdk';
import { isSupportH5ToWeapp } from '@/util/jsapiSupport';
import { showBusinessError } from '@/fit-components/dialog/main';

const unSupportTips = {
  en:
    "Oops! Your phone's operating system or WeChat version is out of date . Please install the latest version in order to view it.",
  'zh-cn': '你需要更新系统或WeChat至最新版本后才能打开噢！',
  'zh-hk': '你需要更新系統或WeChat至最新版本後才能打開噢！',
};

@Component({})
export default class LanuchWeapp extends Vue {
  public isSupportH5ToWeapp = isSupportH5ToWeapp();
  @Prop() public id!: string;
  @Prop() private path!: string;
  @Prop() private username!: string;

  public created() {
    if (!this.isSupportH5ToWeapp) {
      return;
    }
    SDK.init();
  }

  public weappClick() {
    this.$emit('weappclick');
    if (!this.isSupportH5ToWeapp) {
      const lang = this.getLang();
      const errMsg = unSupportTips[lang];
      showBusinessError(errMsg);
    }
    return;
  }

  private getLang() {
    const lang = language.getLang(['zh-cn', 'zh-hk', 'en'], {
      key: 'lang',
      defaultLang: 'zh-hk',
      keyMap: {
        // 台湾也和繁体中文一样处理
        'zh-tw': () => 'zh-hk',
      },
    });
    return lang;
  }

  private mounted() {
    const { id } = this;
    const btn: any = document.getElementById(id);
    if (btn) {
      const p = btn.parentElement.style.position;
      if (!p) {
        btn.parentElement.style.position = 'relative';
      }

      btn.addEventListener('launch', (e) => {
        // console.log('Launch success');
        // console.log(`Will open weapp : ${this.path}`);
      });
      btn.addEventListener('error', (e) => {
        showBusinessError();
        throw e;
      });
    }
  }
}
